import { Button } from "components/DesignSystem/Button/Button";
import { REVIEW_ACTION } from "v2/constants/extractionReview";
import type { ReviewActionFn } from "v2/types/extractionReview.types";

type UndoButtonProps = {
  id: string;
  onAction: ReviewActionFn;
  loading?: boolean;
};

export const UndoButton = ({
  id,
  onAction,
  loading = false,
}: UndoButtonProps) => {
  const handleUndo = () => onAction(id, REVIEW_ACTION.UNDO);
  return (
    <Button
      customType="link_neutral"
      size="small"
      isLoading={loading}
      onClick={handleUndo}
    >
      Undo
    </Button>
  );
};
